export const TREE_PERMISSION_IDS = [106, 110, 111, 186, 478];
export const LEGACY_PERMISSION_IDS = [9999];
export const DEFAULT_ALLOWED_PERMISSIONS = [...TREE_PERMISSION_IDS, ...LEGACY_PERMISSION_IDS];
export const LIMITED_ALLOWED_PERMISSIONS = [110];

export const PERMISSIONS_BY_ROLE_ID: Record<string, number[]> = {
  '1000': [106, 110, 111, 186, 478],
  '1001': [110],
  '1002': [111, 9999],
  '1500': [110, 9999]
};

export const getPermissionsByProfileId = (profileId: string): number[] => {
  return PERMISSIONS_BY_ROLE_ID[profileId] ?? DEFAULT_ALLOWED_PERMISSIONS;
};
